export const isValidNip = (nip) => {
  if (typeof nip !== 'string') return false;

  const digits = nip.replace(/[ -]/g, '');
  if (!/^\d{10}$/.test(digits)) return false;

  const weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  const sum = weights.reduce((acc, weight, i) => acc + weight * Number(digits[i]), 0);

  return sum % 11 === Number(digits[9]);
};

export const pushDataLayerEvent = (event, payload = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...payload });
};

export const genLeadId = () => {
  try {
    if (window.crypto && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {
    // ignore
  }
  return 'lead-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
};

export const bytesToSize = (bytes) => {
  const units = [' kB', ' MB', ' GB'];
  let size = bytes / 1024;
  let i = 0;

  while (size > 1024 && i < units.length - 1) {
    size /= 1024;
    i++;
  }

  return Math.max(size, 0.1).toFixed(1) + units[i];
};

// "Imię i nazwisko" is one field: first word is the first name, the rest is the last name
export const splitName = (name) => {
  const parts = name.split(/\s+/).filter(Boolean);

  return { firstname: parts.shift() || '', lastname: parts.join(' ') };
};
